import { styled } from '@mui/material';
import { Chip } from 'shared/mui/Chips';

export const GatewayRuleFieldChip = styled(Chip)({
  height: '24px',
  padding: '3px 2px',
  marginRight: '4px',
  maxWidth: '60%',
});
